import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getBasePlatform, updateBasePlatform } from '@blade-sxp/device-management/api/device-group-management';
const API = {
    getBasePlatform,
    updateBasePlatform
};
let PlatformCard = class PlatformCard extends Vue {
    basePlatform = {
        port: 5060,
        platformCode: 'DefaultUUID',
        ip: '10.8.10.28',
        deviceId: '32000000002000000016',
    };
    activeNames = '';
    curDeviceId = '';
    created() {
        this.getBasePlatform();
    }
    // 获取本地平台
    getBasePlatform() {
        API.getBasePlatform()
            .then((res) => {
            this.basePlatform = res;
            this.curDeviceId = res.deviceId;
        });
    }
    changePlatform() {
    }
    openCollapse() {
        this.activeNames = this.basePlatform.deviceId;
        this.$emit('openCollapse', 'that');
    }
    cancelForm() {
        this.activeNames = '';
    }
    saveForm() {
    }
};
PlatformCard = __decorate([
    Component({
        name: 'basePlatform',
    })
], PlatformCard);
export default PlatformCard;
